"use strict";

if (typeof window === "undefined") {
  require("dotenv").config();
}
const dbConfig = {
  username: process.env.DB_USERNAME,
  password: process.env.DB_PASSWORD,
  host: process.env.DB_HOST,
  port: process.env.DB_PORT,
  dialect: "mysql",
  logging: false
};
module.exports = {
  environment: "production",
  protocol: "https://",
  api_url: "https://api.totalwinewholesale.com/api",
  distributor_host: "https://app.totalwinewholesale.com/",
  client_host: "totalwinewholesale.com",
  websocket_url: "wss://api.totalwinewholesale.com",
  port: 9301,
  bodyLimit: "5mb",
  sentry: {
    dsn: process.env.SENTRY_DSN
  },
  s3: {
    bucket: process.env.S3_BUCKET,
    access: {
      bucket: process.env.S3_BUCKET,
      endpoint: process.env.S3_ENDPOINT,
      region: process.env.S3_REGION,
      forcePathStyle: false,
      credentials: {
        secretAccessKey: process.env.S3_SECRET_ACCESS_KEY,
        accessKeyId: process.env.S3_ACCESS_KEY_ID
      }
    }
  },
  database: {
    database: process.env.DB_NAME,
    ...dbConfig,
    pool: {
      max: Number(process.env.DB_POOL_MAX) || 15
    },
    dialectOptions: {
      maxPreparedStatements: 3000
    }
  },
  jwt_expiration: "23h",
  customer_jwt_expiration: process.env.CUSTOMER_JWT_EXPIRATION || "96h",
  jwt_encryption: process.env.JWT_ENCRYPTION,
  admin_token_secret: process.env.ADMIN_TOKEN_SECRET,
  mailgun: {
    api_key: process.env.MAILGUN_API_KEY,
    domain: process.env.MAILGUN_DOMAIN,
    sender_address: "cs@totalwinewholesale.com",
    reply_address: "txwholesale@totalwine.com"
  },
  twilio: {
    account_sid: process.env.TWILIO_ACCOUNT_SID,
    auth_token: process.env.TWILIO_AUTH_TOKEN,
    text_from: process.env.TWILIO_FROM_NUMBER
  },
  logs: {
    loggly: {
      token: process.env.LOGGLY_TOKEN,
      subdomain: "ynvoice",
      tags: ["totalwine-api", "totalwine-production"],
      json: true
    }
  },
  otel: {
    endpoint: process.env.OTEL_EXPORTER_OTLP_ENDPOINT,
    authHeader: process.env.OTEL_EXPORTER_OTLP_AUTH,
    environment: "production",
    metricsToken: process.env.METRICS_BEARER_TOKEN,
    // Git SHA of the deploy, set by the deploy workflow.
    serviceVersion: process.env.OTEL_SERVICE_VERSION,
    // Standard OTel SDK variables; "none" turns a signal off. Metrics are
    // scraped from /metrics, so OTLP metric push is opt-in ("otlp").
    tracesExporter: process.env.OTEL_TRACES_EXPORTER || "otlp",
    logsExporter: process.env.OTEL_LOGS_EXPORTER || "otlp",
    metricsExporter: process.env.OTEL_METRICS_EXPORTER || "none"
  },
  clover: {
    api_url: "https://api.clover.com/v3/merchants"
  },
  posthog: {
    api_key: process.env.POSTHOG_API_KEY
  },
  uploaded_fintech_invoice_file_path: "/tmp",
  order_app_subdomain: "order"
};